<!-- 获取停车场图片信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KKN885S",
                "carInTimeFrom": "2000-04-25 00:00:00",
                "carInTimeTo": "2019-04-25 17:20:00"
            },
            responseCode: {
                "data": {
                "resultList": [
                    {
                        "normalParkingCar": 0,
                        "parkCode": "2KKN885S",
                        "parkName": "昌俊停车场",
                        "parkingLotSeq": 1,
                        "parkingStatisticalAreaName": "昌俊停车场",
                        "parkingStatisticalAreaSeq": 1,
                        "totalParkingCar": 0,
                        "vipParkingCar": 0
                    },
                    {
                        "normalParkingCar": 0,
                        "parkCode": "2KKN885S",
                        "parkName": "昌俊停车场",
                        "parkingLotSeq": 1,
                        "parkingStatisticalAreaName": "新区域",
                        "parkingStatisticalAreaSeq": 10,
                        "totalParkingCar": 0,
                        "vipParkingCar": 0
                    },
                    {
                        "normalParkingCar": 0,
                        "parkCode": "2KKN8851",
                        "parkName": "test",
                        "parkingLotSeq": 21,
                        "parkingStatisticalAreaName": "test",
                        "parkingStatisticalAreaSeq": 23,
                        "totalParkingCar": 0,
                        "vipParkingCar": 0
                    },
                    {
                        "normalParkingCar": 0,
                        "parkCode": "001",
                        "parkName": "测试停车场",
                        "parkingLotSeq": 22,
                        "parkingStatisticalAreaName": "测试停车场",
                        "parkingStatisticalAreaSeq": 24,
                        "totalParkingCar": 0,
                        "vipParkingCar": 0
                    }
                ]
            },"message":"业务成功","resultCode":0,"status":1},
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取停车场区域在场车位数",
                t_url: this.commonUrls.test+"getParkAreaPresentCarNum",
                p_url: this.commonUrls.prod+"getParkAreaPresentCarNum",
                precondition: "无",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'carInTimeFrom', info2: '是', info3: 'String', info4: '车辆进场起始时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'carInTimeTo', info2: '是', info3: 'String', info4: '车辆进场结束时间，yyyy-MM-dd HH:mm:ss' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'resultList', info2: '是', info3: 'JSONArray', info4: '记录列表' }
                        ]
                },{
                    titleName: 'resultList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'parkingLotSeq', info2: '是', info3: 'String', info4: '车场图片链接' },
                        { info1: 'parkingStatisticalAreaSeq', info2: '是', info3: 'Integer', info4: '该停车场区域递增递增序列号' },
                        { info1: 'parkingStatisticalAreaName', info2: '是', info3: 'String', info4: '该停车场区域名称' },
                        { info1: 'totalParkingCar', info2: '是', info3: 'String', info4: '在场总车辆数' },
                        { info1: 'normalParkingCar', info2: '是', info3: 'Integer', info4: '在场临时车总车辆数' },
                        { info1: 'vipParkingCar', info2: '是', info3: 'Decimal', info4: '在场vip总车辆数' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/yard/getParkAreaPresentCarNum.vue